import { render, staticRenderFns } from "./PrinterBtn.vue?vue&type=template&id=2a136096&"
import script from "./PrinterBtn.vue?vue&type=script&lang=js&"
export * from "./PrinterBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports